import { alpha } from "@mui/material/styles";
import type { Components } from "@mui/material/styles";

import type { Theme } from "../types";

export const MuiCssBaseline = {
	styleOverrides: (theme: Theme) => ({
		"*": {
			scrollbarColor: `${alpha(theme.palette.text.primary, 0.18)} transparent`,
			scrollbarWidth: "thin",
		},
		"*::-webkit-scrollbar": {
			width: "8px",
			height: "8px",
		},
		"*::-webkit-scrollbar-track": {
			backgroundColor: "transparent",
		},
		"*::-webkit-scrollbar-thumb": {
			backgroundColor: alpha(theme.palette.text.primary, 0.18),
			borderRadius: "4px",
		},
		"*::-webkit-scrollbar-thumb:hover": {
			backgroundColor: alpha(theme.palette.text.primary, 0.3),
		},
		"*::-webkit-scrollbar-corner": {
			backgroundColor: "transparent",
		},
	}),
} satisfies Components<Theme>["MuiCssBaseline"];
